// src/hooks/useFileSelection.js
import { useState, useCallback } from "react";

export const useFileSelection = (initialSeqType = "riboseq") => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedSeqType, setSelectedSeqType] = useState(initialSeqType);
  const [selectedGroup, setSelectedGroup] = useState("all");

  const toggleFile = useCallback((fileId) => {
    setSelectedFiles((prev) => {
      if (prev.includes(fileId)) {
        return prev.filter((id) => id !== fileId);
      } else {
        return [...prev, fileId];
      }
    });
  }, []);

  const selectMultipleFiles = useCallback((fileIds) => {
    setSelectedFiles((prev) => {
      const newFiles = fileIds.filter((id) => !prev.includes(id));
      return [...prev, ...newFiles];
    });
  }, []);

  const deselectMultipleFiles = useCallback((fileIds) => {
    setSelectedFiles((prev) => prev.filter((id) => !fileIds.includes(id)));
  }, []);

  const toggleAllFiles = useCallback(
    (fileIds, select = true) => {
      if (select) {
        selectMultipleFiles(fileIds);
      } else {
        deselectMultipleFiles(fileIds);
      }
    },
    [selectMultipleFiles, deselectMultipleFiles]
  );

  const clearSelection = useCallback(() => {
    setSelectedFiles([]);
  }, []);

  const setSelectedFilesDirectly = useCallback((fileIds) => {
    setSelectedFiles(fileIds);
  }, []);

  return {
    selectedFiles,
    selectedSeqType,
    selectedGroup,
    toggleFile,
    toggleAllFiles,
    selectMultipleFiles,
    deselectMultipleFiles,
    setSelectedSeqType,
    setSelectedGroup,
    clearSelection,
    setSelectedFiles: setSelectedFilesDirectly,
  };
};
